import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { Observable, tap } from 'rxjs';
import { CuttedMaterialStatistic } from '../../models/cutting/cutted-material-statistic.model';

export class CuttedMaterialStatisticDialogData {
  statistic: CuttedMaterialStatistic;
  boardsStatistic?: CuttedMaterialStatistic[] = [];
}
@Component({
  templateUrl: './cutted-material-statistic-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CuttedMaterialStatisticDialogComponent implements OnInit {
  statisticsForOneCard: UntypedFormControl = new UntypedFormControl(-1);
  showingStatistic: CuttedMaterialStatistic;
  action$: Observable<void>;

  constructor(@Inject(MAT_DIALOG_DATA) public data: CuttedMaterialStatisticDialogData) {
    this.showingStatistic = this.data.statistic;
  }

  ngOnInit(): void {
    this.action$ = this.statisticsForOneCard.valueChanges.pipe(
      tap(() => {
        if (this.statisticsForOneCard.value === -1) {
          this.showingStatistic = this.data.statistic;
          return;
        }
        this.showingStatistic = this.data.boardsStatistic[this.statisticsForOneCard.value];
      })
    );
  }

  getKIMWithCutOffs(): number {
    return (
      (this.showingStatistic?.detailArea + this.showingStatistic?.squareScraps) / this.showingStatistic?.boardsArea
    );
  }

  squareMm2squareM(squareMm: number): number {
    return squareMm / 1e6;
  }

  mm2m(mm: number): number {
    return mm / 1000;
  }
}
